export const messageDetailReducer = (messageDetail = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case "MESSAGE_STATUS_TYPE":
      return {
        ...messageDetail,
        statusTypes: payload,
      };
    case "CHANGE_DASHBOARD_STATUS":
      const { prev, updated } = payload;

      return {
        ...messageDetail,
        ...(messageDetail.statusTypes[`${prev}`] -= 1),
        ...(messageDetail.statusTypes[`${updated}`] += 1),
      };
    default:
      return messageDetail;
  }
};
